import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToHms'
})
export class SecondsToHmsPipe implements PipeTransform {

  transform(value: any):any {
    let seconds = parseInt(value);
    if (seconds === 0) {
      return  value + "s";
    }
    var h = Math.floor(seconds / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor((seconds % 3600) % 60);

    var hDisplay = h > 0 ? (h + "h ") : "";
    var mDisplay = m > 0 ? (m + "m ") : "";
    var sDisplay = s > 0 ? (s + "s") : "";
    return hDisplay + mDisplay + sDisplay;
  }

}
